import { cn } from "@/lib/utils";

export type FolderColor = {
  value: string;
  label: string;
};

type FolderColorPickerProps = {
  colors: FolderColor[];
  value: string;
  onChange: (value: string) => void;
  ariaLabel?: string;
};

export default function FolderColorPicker({
  colors,
  value,
  onChange,
  ariaLabel,
}: FolderColorPickerProps) {
  return (
    <div
      role="radiogroup"
      aria-label={ariaLabel}
      className="flex items-center gap-1.5 px-1"
    >
      {colors.map((color) => {
        const checked = value === color.value;
        return (
          <button
            key={color.value}
            type="button"
            role="radio"
            aria-checked={checked}
            aria-label={color.label}
            tabIndex={checked || (!colors.some((c) => c.value === value) && color === colors[0]) ? 0 : -1}
            onClick={() => onChange(color.value)}
            onKeyDown={(e) => {
              if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
              e.preventDefault();
              const idx = colors.findIndex((c) => c.value === value);
              const next =
                e.key === "ArrowRight"
                  ? (idx + 1) % colors.length
                  : (idx - 1 + colors.length) % colors.length;
              onChange(colors[next].value);
            }}
            className={cn(
              "h-5 w-5 cursor-pointer rounded-full transition-transform focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
              checked && "scale-110 ring-2 ring-offset-1 ring-foreground/40"
            )}
            style={{ backgroundColor: color.value }}
            title={color.label}
          />
        );
      })}
    </div>
  );
}
